export default __webpack_public_path__ + "static/media/suitcase-icon.d63ade99.png";